@if (endorsementLocation?.statusCode !== 'SIGNED') {
  <button
    class="initials-endorsement__button"
    appDebounceClick
    (debouncedClick)="endorsementClicked()"
    [debounceTimer]="500"
    [hidden]="!endorsementLocation?.isSignableInCurrentSession"
    [tabindex]="disableFocus ? -1 : 0"
  [attr.data-testid]="
    'endorsement-initials-' + this.endorsementLocation?.documentEndorsementLocationId
  "
    [disabled]="shouldDisable"
    >
    <span class="fas fa-pen-nib initials-endorsement__icon"></span>
  </button>
} @else {
  <div
    class="initials-endorsement__image-wrapper"
    >
    <img
      [ngClass]="{
        'initials-endorsement__image': true,
        'initials-endorsement__image--hidden': hideIfSigned
      }"
      [src]="'data:image/png;base64,' + endorsementImage?.endorsementImage"
      alt="initials"
      [attr.data-testid]="
        'endorsement-initials-completed-' + this.endorsementLocation?.documentEndorsementLocationId
      "
      data-private
      />
      @if (endorsementLocation?.isSignableOnDevice && !shouldDisable) {
        <span
          class="initials-endorsement__erase-icon fa-solid fa-circle-xmark"
          appDebounceClick
          (debouncedClick)="eraseEndorsementClicked()"
          [debounceTimer]="500"
          >
        </span>
      }
    </div>
  }

